export enum RewardEventType {
    ReplacementRequested = 'ReplacementRequested',
    StatusChanged = 'StatusChanged',
    Mailed = 'Mailed',
    Processed = 'Processed',
    Reloaded = 'Reloaded',
    EmailResent = 'EmailResent',
}

export default RewardEventType;
